export default __webpack_public_path__ + "static/media/block.e8bd25cf.svg";